import { render } from "./CreateClass.vue?vue&type=template&id=54ead8ac&ts=true"
import script from "./CreateClass.vue?vue&type=script&lang=ts"
export * from "./CreateClass.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__